import type { StatsSnapshot } from './gameplay-snapshot';
import { useCurrencyStore } from '../store/zustand/useCurrencyStore';
import { multiplyAll, sumAll } from '@game-libs/exc-libs/src/helpers/array.helpers';
import { CONFIG } from '../config';
import { unitStats as stats } from './index';

export const updateWarriorStats = (state: StatsSnapshot) => {
  const upgrades = state.upgrades.warrior;
  const wizardUpgrades = state.upgrades.wizard;
  const warrior = state.generators.warrior;
  const wizard = state.generators.wizard;

  const baseDamage = warrior.baseGeneration + upgrades.barbarian.multiplier;

  const currency = useCurrencyStore.getState();
  const inspirationMultiplier = currency.inspiration.remainingActive > 0 ? currency.inspiration.multiplier : 1;

  // Base damage multiplier (without mana sword)
  const baseDamageMultiplier = multiplyAll([
    upgrades.shortSword.multiplier,
    upgrades.longSword.multiplier,
    inspirationMultiplier,
  ]);

  // Each Wizard imbues 1 Warrior's sword with Mana when mana is above 90
  const imbuedWarriors = currency.mana >= 90 ? Math.min(wizard.owned, warrior.owned) : 0;
  const nonImbuedWarriors = warrior.owned - imbuedWarriors;

  // Imbued warriors get the mana sword multiplier
  const imbuedDamage = baseDamage * baseDamageMultiplier * wizardUpgrades.manaSword.multiplier * imbuedWarriors;
  const nonImbuedDamage = baseDamage * baseDamageMultiplier * nonImbuedWarriors;

  const goldMultiplier = multiplyAll([upgrades.silverBlade.multiplier, upgrades.goldenBlade.multiplier]);

  const damagePerTick =
    imbuedDamage + nonImbuedDamage + warrior.purchased * baseDamage * upgrades.loyalMercenaries.multiplier;

  const goldGeneration = damagePerTick * CONFIG.game.goldPerDamage * goldMultiplier;

  const inspirationGeneration = sumAll([upgrades.battleShout.multiplier, upgrades.warCry.multiplier]);

  stats.warrior = {
    mainIndividualGenerationStat: baseDamage * baseDamageMultiplier,
    damagePerTick,
    goldGeneration,
    inspirationGeneration,
  };
};
